import React from 'react';
import { CommentLayoutProvider } from './CommentLayoutProvider';
import Container from './Container';

const ScenarioSelectionScenarioDetailsTemplate = () => {
  return (
    <CommentLayoutProvider>
      <Container />
    </CommentLayoutProvider>
  );
};

export default ScenarioSelectionScenarioDetailsTemplate;
